
export const baseLight=' #ffffff';
export const lineExtra=' #C1D3F1';
export const basePrimary=' #284073';
export const baseSecondary='#DBEAFE';
export const baseAccent='#2563EB';
export const backgroundPrimary='#F0F6FF';
export const greenColor='greeen'
export const blackColor='black'
export const blueColor='blue'

//Arrows
export const ARROW_COLOR_Base = '#7085B2';
export const ARRROW_LINK_TASK_COLOR = '#1d507a'
export const ARRROW_LINK_SUBCONTRACT_COLOR = "rgb(87, 144, 167)";
export const ARROW_DAGRE_NEXT_TASK_COLOR = '#8f4d4d';

//Buttons Nodes
export const BUTTON_TEXT_COLOR = '#DBEAFE'
export const BUTTON_COLOR = '#2563EB'
export const BUTTON_COLOR_ACTIVE = '#1b48a8ff'
export const TOOLTIP_BUTTON_COLOR = '#2563EB'
export const TOOLTIP_BUTTON_COLOR_TEXT = basePrimary

//Nodes BP
export const BP_ACTIVE_STEP_COLOR = '#222425'

export const textPrimary = '#1E2938';